import globalEventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'

let $page = $('#team')
let $teamButton = $('button.team')

globalEventBus.on('player want to display team page', show)

globalEventBus.on('button menu clicked', hide)

globalEventBus.on('menu hidden', hideButton)
globalEventBus.on('menu displayed', showButton)


$teamButton.click(globalEventBus.emitter('player want to display team page'))


let fadeDelay = 500

function show () {
    $page.fadeIn(fadeDelay)
    globalEventBus.emit('team page displayed')
}



function hide () {
    $page.fadeOut(fadeDelay)
    globalEventBus.emit('team page hidden')
}



function hideButton () {
    $teamButton.fadeOut(fadeDelay)
}



function showButton () {
    $teamButton.fadeIn(fadeDelay)
}

